import ScreenWrapper from "@/components/ScreenWrapper"
import { createFileRoute } from "@tanstack/react-router"

export const Route = createFileRoute("/beheer/gebruikers/")({
  component: RouteComponent,
})

function RouteComponent() {
  return <ScreenWrapper showManagementMenu>Gebruikers</ScreenWrapper>
}
